import { createFileRoute } from '@tanstack/react-router';
import { LandingPage } from '../LandingPage.js';

export const Route = createFileRoute('/')({ component: LandingPage });
